<template>
    <div>
        <buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <div>
                    <el-tabs :tab-position="'top'" type="">
                        <el-tab-pane :label="$t('getapi[930]')">
                            <div style="background: white;white-space: nowrap;overflow: auto">
                                <el-button type="primary" size="mini" @click.native.prevent="showAddMaterials">{{$t('getapi[878]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click.native.prevent="batchEdl">{{$t('getapi[7241]')}}</el-button>
                            </div>
                            <el-table :data="dataSetMaterials"
                                      :height="tableHeight  - reduceTableHeight"
                                      header-row-class-name="headerclass"
                                      @selection-change="handleSelectionChange" 
                                      :row-class-name="tableRowClassName" border size="mini"
                                      style="width: 100%; margin-top:0px"
                                      :header-cell-style="$limits.headerClass"
                                      ref="singleTable">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID"
                                                 v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <!-- <el-table-column fixed="right" :label="$t('getapi[6048]')">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delMaterials(scope.$index)"
                                        >
                                            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[3889]')
                                                }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                    <div style="position: absolute;bottom:10px">
                        <el-button type="primary" size="mini" @click.native.prevent="selectInfo()">{{$t('getapi[1980]')}}</el-button>
                    </div>
                </div>
                
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    <!-- <el-tab-pane :label="$t('getapi[1625]')" > -->
                        <el-table
                            :data="Lists"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            v-loading="dloading"
                            border
                            stripe
                            size="mini"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:0px"
                            :height="tableHeight"
                        >
                            <el-table-column show-footer-overflow prop="row_number" :label="$t('getapi[1425]')" sortable  align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="f_part_code" :label="$t('getapi[740]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="f_part_version" :label="$t('getapi[741]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_master_unit" :label="$t('getapi[4590]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mount" :label="$t('getapi[726]')" align="right" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="scrapMount" :label="$t('getapi[917]')" align="right" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="purchase_leadtime" :label="$t('getapi[158]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="category_first" :label="$t('getapi[169]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="category_second" :label="$t('getapi[170]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="category_third" :label="$t('getapi[171]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="planning_code" :label="$t('getapi[736]')" sortable></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[4364]')" sortable></el-table-column>
                        </el-table>                        
                    <!-- </el-tab-pane> -->
                </div>
            </li>
        </ul>
        <!-- 新增物料弹框 -->
        <selector :isVisible="addmaterialsvisible" :selectType="19" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterials"></selector>
        
        <selector :isVisible="isShowItem" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getproject" ref="input"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'bomprocesslist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-180,
                    maxHeight: this.$windowSize.tableHeight-180,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
        },
        data() {
            return {
                dataSetMaterials: [], //物料
                dataSetPlanNumber: [], //计划清单
                loading: false,
                addmaterialsvisible: false, // 新增物料弹窗
                selectIDData: [], // 物料多选ID合集
                selectIDPlanData: [], // 物料多选ID合集
                selectIndex: 0, // 分页
                select1Data: [], // 多选（按采购件新算法）
                select2Data: [], // 多选（按采购件）
                PlanNo: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                isShowItem: false,
                reduceTableHeight: Common.reduceTableHeight1_1,
                tabNo:"0",
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                activeName:'1',
                title:"",
                scrollTop:0,
                Lists:[],
                dloading: false,
            };
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.$limits.dragControllerDiv1();
            that.authority();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        methods: {                      
            tableRowClassName({row, rowIndex}){
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8179]"),this.$t("getapi[18]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                that.$refs.SetBtn.SetButtonEnable('export');
            },
            //查询
            selectInfo() {
                let that = this;
                that.loading = true;
                let partlist = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    partlist.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        exclusively_id: that.dataSetMaterials[i].exclusively_id,
                    });
                }
                let parm = {
                    partlist: partlist,
                    LangType: that.$processdata.getLang(),
                };
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Eng/Boms/GetBomPurchaseProcLists', parm, function (res) {
                    if (res.Success == 1) {
                        that.Lists = res.DataContent;
                        that.$nextTick(function () {
                            that.$processdata.initForm(1)
                        })
                    }
                    that.loading = false;
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 150 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 添加物料
            showAddMaterials() {
                let that = this;
                that.addmaterialsvisible = true;
                that.$refs.addmaterials.clearInput(that.addmaterialsvisible, true, 4);
            },
            addmaterials(data) {
                let that = this;
                for (let i = 0; i < data.length; i++) {
                    that.dataSetMaterials = [
                        ...that.dataSetMaterials,
                        {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            exclusively_id: data[i].exclusively_id,
                        }
                    ];
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].exclusively_id);
                }
            },
            // 计划单号清单批量选择
            handleSelectionPlanChange(val) {
                let that = this;
                that.selectIDPlanData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDPlanData.push(val[i].$index);
                }
            },
            // 批量删除
            batchEdl() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            // 计划单号清单批量删除
            batchEdlPlan() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            
            //导出
            exps() {
                let that = this;
                //that.selectIndex = tab.name;
                that.loading = true;
                let partlist = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    partlist.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        exclusively_id: that.dataSetMaterials[i].exclusively_id,
                    });
                }
                let parm = {
                    partlist: partlist,
                };
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Eng/Boms/GetBomPurchaseProcListsToExcel', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            
            //  删除物料
            delMaterials(index) {
                let that = this;
                that.dataSetMaterials.splice(index, 1);
            },
            selectItem_code() {
                let that = this;
                that.isShowItem = true;
                that.$refs.input.clearInput(this.isShowItem);
            },
            getproject(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if(this.$route.name == this.$options.name){
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[1],
                            exclusively_id: '',
                        }]
                    } else {
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[2],
                            exclusively_id: '',
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    let parm = {
                        list: arrlist
                    }
                    that.$http.urlpost('/Eng/Boms/GetBomPartVersion_Process', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent.List
                            for (let i = 0; i < data.length; i++) {
                                that.dataSetMaterials = [...that.dataSetMaterials, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    exclusively_id: data[i].exclusively_id
                                }]
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
